<div (click)="goToDetails()">
  <div class="or-d-flex or-justify-content-between or-align-items-center or-mt-8-px">
    <div class="or-head-lg">{{ teamDetails().teamName }}</div>
    @if (showShareIcon() && teamDetails().memberRole !== 'Member') {
      <or-icon (click)="share($event)" name="copy-link" size="s" boxed class="or-color-white or-bg-main-1" />
    }
  </div>

  @if (showInfoLabel()) {
    <div class="or-mt-8-px or-text-sm or-color-secondary-2">
      {{ teamDetails().memberRole !== 'Member' ? hostInfoText : memberInfoText }}
    </div>
  }

  <div class="or-my-12-px">
    <div class="or-d-flex or-align-items-center">
      @for (
        member of teamDetails().members | slice: 0 : (teamDetails().members.length === 5 ? 5 : 4);
        track member.userId
      ) {
        <div class="negative-margin-left-20-px">
          <lib-or-avatar
            [avatarUrl]="member.thumbnail"
            [initials]="member.displayName"
            [showWhiteBorder]="true"
            [avatarSize]="'sm'"></lib-or-avatar>
        </div>
      }
      <div class="or-text-md or-color-secondary-2">{{ teamDetails().members.length }} graczy</div>
    </div>
  </div>

  <div class="or-d-flex">
    <div
      (click)="goToChat($event)"
      class="border-shade border-radius-4 or-p-8-px or-mr-8-px or-w-100-pc or-bg-white or-d-flex or-align-items-center">
      <or-icon name="messages" size="s" class="or-mr-8-px" />
      <div class="or-text-md or-my-4-px">Chat grupki</div>
    </div>

    @if (teamDetails().memberRole !== 'Member') {
      <div
        (click)="goToAutoApprove($event)"
        class="border-shade border-radius-4 or-p-8-px or-w-100-pc or-bg-white or-d-flex or-align-items-center">
        <or-icon name="star" size="s" class="or-mr-8-px or-color-main-1" />

        <div class="or-text-md or-my-4-px">Ulubieni gracze</div>
      </div>
    }
  </div>
</div>
